module.exports = __webpack_public_path__ + "static/logo-ai2-fullColor-withText-8255da7cf6cf79edaa69c50d390668f0.svg";